import { render, staticRenderFns } from "./ps_org_password_settings_page.vue?vue&type=template&id=051eedf4&"
import script from "./ps_org_password_settings_page.vue?vue&type=script&lang=js&"
export * from "./ps_org_password_settings_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports